import * as React from "react";

import type { AppSplitButtonProps } from "@1js/acui-button";
import { UILocation } from "@1js/acui-common";
import type { AppIcons } from "@1js/acui-icons";
import type { ControlInMenuRendererFunction } from "@1js/acui-menu";

import { RibbonSplitButton } from "../Controls";

export function getDefaultSplitButtonRenderer(
  appIcons: AppIcons,
  controlInMenuRendererFunction: ControlInMenuRendererFunction
) {
  return (props: AppSplitButtonProps) => (
    <RibbonSplitButton
      {...props}
      controlInMenuRendererFunction={controlInMenuRendererFunction}
      downChevronIcon={appIcons.downChevron}
      location={props.location || UILocation.Ribbon}
    />
  );
}
